<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-col cols="12" sm="12">
      <v-card class="box">
        <v-col cols="12" sm="12">
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong> Apply Assessment Scheme </strong>
            </v-toolbar-title>
          </v-toolbar>
          <!-- {{ this.scheme_list }} -->
          <v-row justify="center" class="p-0 m-0">
            <v-col class="p-0 m-0" cols="12" sm="4" md="4">
              <v-autocomplete
                class="pt-2"
                dense
                required
                outlined
                rounded
                color="#0F2027"
                v-model="ay"
                :items="ay_list"
                item-text="ay"
                item-value="id"
                label="Academic Year"
                persistent-hint
                hint="Please select Academic Year"
              />
            </v-col>
            <v-col class="p-0 m-0" cols="12" sm="4" md="4">
              <v-autocomplete
                class="pt-2"
                dense
                required
                outlined
                rounded
                color="#0F2027"
                v-model="sem"
                :items="semester_list"
                item-text="name"
                item-value="id"
                label="Semester"
                persistent-hint
                hint="Please select semester"
              />
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="p-0 m-0">
            <v-btn dense outlined rounded class="button" @click="get_all_data()"
              >Proceed</v-btn
            >
          </v-row>
          <v-row dense>
                <v-spacer></v-spacer>
                <v-col sm="2" v-if="previousAyList && previousAyList.length > 0">
                    <v-btn class="mt-6 button" @click="copyDialog = true">Copy from Previous AY</v-btn>
                </v-col>
            </v-row>
          <span v-if="ay != null">
            <span v-if="scheme_list == 'not applied'">
              <v-row justify="center" class="p-0 m-0">
                <strong
                  >Assessment scheme is not offered for this academic year
                  please offer scheme</strong
                >
              </v-row>
            </span>
            <span v-else>
              <v-row class="p-0 m-0" v-if="scheme_list.length > 0">
                <!--  <span class="slide">*NOTE: Assessment scheme will applied only those courses which has mark entry type is "Marking" !!!</span> -->
                <v-col class="p-0 m-0" cols="12" sm="6" md="6"> </v-col>
                <v-col class="p-0 m-0" cols="12" sm="6" md="6">
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search in table"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- {{scheme_list}} -->
              <v-data-table
                v-if="scheme_list.length > 0"
                dense
                :headers="headers"
                :items="scheme_list"
                :items-per-page="-1"
                class="elevation-1 mytable"
              >
                <template v-slot:item.options="{ item }">
                  <v-btn
                    class="btn-css btn"
                    @click="getstd_crs(item.std_id, item.ay_id, item.sem_id)"
                  >
                    {{ item.std }}
                  </v-btn>
                </template>
                <template v-slot:item.scheme="{ item }" class="p-0 m-0">
                  <!-- @change="setscheme(item.std_id,type='std')"  -->
                  <v-row justify="center">
                    <v-autocomplete
                      v-if="item.status != 'No courses for this standard'"
                      class="pt-2 pb-0 m-0"
                      dense
                      required
                      outlined
                      rounded
                      color="#0F2027"
                      v-model="item.apllied_scheme"
                      :items="assesmet_scheme_list"
                      item-text="s_name"
                      return-object
                      label="Assessment Scheme"
                      persistent-hint
                      hint="Please select Assessment Scheme"
                    />
                    <v-span justify="center" v-else>
                      No courses offered for standard
                    </v-span>
                    <v-btn
                      rounded
                      v-if="item.status != 'No courses for this standard'"
                      class="button"
                      @click="
                        setscheme(
                          item.std_id,
                          (type = 'std'),
                          null,
                          item.apllied_scheme,
                          item.sem_id,
                          item.ay_id
                        )
                      "
                      >Apply</v-btn
                    >
                  </v-row>
                </template>
              </v-data-table>
              <v-row align="center" justify="center">
                <v-btn
                  dense
                  outlined
                  v-if="scheme_list.length > 0"
                  :loading="loader"
                  rounded
                  class="button"
                  @click="save(scheme_list)"
                  >Apply All</v-btn
                >
              </v-row>
            </span>
            <v-dialog v-model="dialog" persistent max-width="1200px">
              <v-card>
                <v-toolbar class="toolbar" flat dense>
                  <v-toolbar-title>
                    <strong> Standard Courses </strong>
                  </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                  <v-card class="box">
                    <v-row justify="center" v-if="crs_list == ''">
                      <strong>No courses offered for standard</strong>
                    </v-row>
                    <v-data-table
                      v-if="crs_list != ''"
                      dense
                      :headers="headers1"
                      :items="crs_list"
                      class="elevation-1 mytable"
                      :items-per-page="-1"
                    >
                     <template v-slot:item.assessmentscheme="{ item }" >
                        {{ item.assessmentscheme }}
                        <v-row justify="center" v-if="item.assessmentscheme!='Not Applied'">
                          <v-btn class="button" rounded small @click="calldeleteScheme(item)" > Delete </v-btn>
                        </v-row>
                    </template>

                      <template v-slot:item.options="{ item }">
                        <v-row justify="center">
                          <v-autocomplete
                            class="pt-2"
                            dense
                            required
                            outlined
                            rounded
                            color="#0F2027"
                            v-model="item.apllied_scheme"
                            :items="ass_scheme_list"
                            item-text="s_name"
                            return-object
                            label="Assessment Scheme"
                            persistent-hint
                            hint="Please select Assessment Scheme"
                          />
                          <!-- <v-span justify="center" v-else>
                                                <strong>No courses offered for standard</strong>
                                            </v-span> -->
                          <v-btn
                            rounded
                            class="button"
                            @click="
                              setscheme(
                                item.std_id,
                                (type = 'course'),
                                item.crs_id,
                                item.apllied_scheme,
                                item.sem_id,  
                                item.ay_id
                              )
                            "
                            >Apply</v-btn
                          >
                        </v-row>
                      </template>
                    </v-data-table>
                    <v-row justify="center">
                      <v-btn rounded class="button" @click="dialog = false"
                        >Close</v-btn
                      >
                    </v-row>
                  </v-card>
                </v-col>
              </v-card>
            </v-dialog>
            <v-dialog v-model="copyDialog" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Copy from Previous Academic Year
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col sm="12">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="copy_from_ay" return-object
                        :items="previousAyList" item-text="name" item-value="id" label="Academic Year" outlined
                        persistent-hint hint="Please Select Academic Year" />
                </v-col>

                <v-col sm="12">
                  <v-icon color="error">*</v-icon>
                    <v-autocomplete multiple dense rounded placeholder="Please select the Standard"
                        v-model="copyStandardList" :items="standardList || []" item-text="name" item-value="id"
                        outlined>
                        <template #label>
                            Copy for Standards <span style="color:red">*</span>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                                <span>{{ item.name }}</span>
                            </v-chip>
                            <span v-if="index === 1" class="grey--text text-caption">
                                (+{{ copyStandardList.length - 1 }} others)
                            </span>
                        </template>
                        <template v-slot:prepend-item>
                            <v-list-item @mousedown.prevent>
                                <v-list-item-action>
                                    <v-checkbox v-model="allStandardSelected" label="Select All"
                                        @change="toggle_standard()" />
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider class="mt-0"></v-divider>
                        </template>
                    </v-autocomplete>
                </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer> </v-spacer>                    
                    <v-btn color="primary" @click="copyAssesmentScheme">Copy</v-btn>
                    <v-btn color="primary" text @click="copyDialog = false" outlined>
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
          </span>
        </v-col>
      </v-card>
    </v-col>
    <div 
      v-if="showConfirmationDialog" 
      style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); display: flex; justify-content: center; align-items: center; z-index: 9999;"
    >
      <div style="background: white; padding: 24px; border-radius: 8px; width: 400px; text-align: center; box-shadow: 0 4px 12px rgba(0,0,0,0.15);">
        <h3 style="margin-top: 0; margin-bottom: 16px; color: #333; font-size: 1.25rem;">
          Delete Assessment Scheme
        </h3>
        
        <p style="color: #555; margin-bottom: 24px; font-size: 0.95rem; line-height: 1.5;">
          Are you sure you want to delete this Assessment Scheme?
        </p>
        
        <div style="display: flex; justify-content: space-between; gap: 16px;">
          <button 
            @click="showConfirmationDialog=false" 
            style="flex: 1; padding: 10px; border: 1px solid #d1d5db; background: white; color: #374151; border-radius: 4px; cursor: pointer; font-weight: bold;"
          >
            Cancel
          </button>
          
          <button 
            @click="deleteScheme(c_id)" 
            style="flex: 1; padding: 10px; border: none; background: #283593; color: white; border-radius: 4px; cursor: pointer; font-weight: bold;"
          >
            Yes, Proceed
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      snackbar_msg: null,
      c_id:null,
      snackbar: false,
      loader: false,
      copyDialog: false,
      copy_from_ay: null,
      copyStandardList: [],
      allStandardSelected: false,
      showConfirmationDialog:false,
      isConfirmed:false,
      standardList: [],
      previousAyList : [],
      color: "",
      ay_list: [],
      ay: null,
      search: null,
      scheme_list: [],
      crs_list: [],
      dialog: false,
      ass_scheme_list: [],
      scheme: null,
      type: null,
      assesmet_scheme_list: [],
      semester_list: [],
      sem: null,
      std_id: null,
      headers: [
        {
          text: "Sr. No.",
          sortable: false,
          value: "srno",
        },

        {
          text: "Academic Year",
          align: "center",
          sortable: false,
          value: "ay",
        },
        {
          text: "Standard",
          align: "center",
          sortable: false,
          value: "options",
        },
        {
          text: "Scheme Status",
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: "Apply Scheme",
          align: "center",
          sortable: false,
          value: "scheme",
        },
      ],
      headers1: [
        {
          text: "Sr. No.",
          sortable: false,
          value: "srno",
        },
        {
          text: "Course",
          align: "center",
          sortable: false,
          value: "crs_name",
        },
        {
          text: "Academic Year",
          align: "center",
          sortable: false,
          value: "ay",
        },
        {
          text: "Standard",
          align: "center",
          sortable: false,
          value: "std",
        },
        {
          text: "Current Scheme",
          align: "center",
          sortable: false,
          value: "assessmentscheme",
        },
        {
          text: "Apply Scheme",
          align: "center",
          sortable: false,
          value: "options",
        },
      ],
    };
  },
  mounted() {
    this.onload();
  },
  methods: {

    toggle_standard() {
        this.$nextTick(() => {
            this.copyStandardList = this.allStandardSelected
                ? this.standardList.map((x) => x.id)
                : [];
        });
    },

    save(scheme_list) {
      for (var i = 0; i < scheme_list.length; i++) {
        if (scheme_list[i].status != "No courses for this standard") {
          if (scheme_list[i].apllied_scheme == null) {
            this.showSnackbar(
              "#b71c1c",
              "Please add assessment scheme to all!!!"
            );
            return;
          }
          if (scheme_list[i].apllied_scheme != null) {
            if (scheme_list[i].apllied_scheme.s_id) {
              scheme_list[i].apllied_scheme =
                scheme_list[i].apllied_scheme.s_id;
            }
          }
        }
      }
      this.loader = true;
      const data = {
        scheme_list: scheme_list,
      };
      axios
        .post("/examination/setAllData", data)
        .then((res) => {
          if (res.data.status == "YES") {
            this.showSnackbar(
              "#4caf50",
              "Assessment Scheme applied successfully"
            );
            this.loader = false;
            this.get_all_data();
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.loader = false;
        })
        .finally(() => {
          //stop loader
          this.loader = false;
        });
    },
    get_all_data() {
      const formData = {
        ay: this.ay,
        sem: this.sem,
      };
      axios
        .post("/examination/get_all_data", formData)
        .then((res) => {
          this.scheme_list = res.data.scheme_list;
          this.previousAyList = res.data.previousAyList;
          this.standardList = res.data.standardList;
          // this.ay_list = res.data.academic_year_list;
          this.assesmet_scheme_list = res.data.assessment_scheme_list;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          //stop loader
        });
    },
    setscheme(std_id, type, course, assessment_scheme, sem_id, ay_id) {
      if (assessment_scheme == "undefined" || assessment_scheme == null) {
        this.showSnackbar("#b71c1c", "Please select Assessment Scheme !!...");
        return;
      }
      if (type == "std") {
        if (assessment_scheme.s_id.length > 1) {
          this.showSnackbar("#b71c1c", "Please select Grading Scheme !!...");
          return;
        }
      }
      const data = {
        std: std_id,
        type: type,
        course: course,
        assessment_scheme: assessment_scheme.s_id,
        sem: sem_id,
        ay: ay_id,
      };
      axios
        .post("/examination/setscheme", data)
        .then((res) => {
          if (res.data.status == "YES") {
            this.showSnackbar(
              "#4caf50",
              "Assessment Scheme applied successfully"
            );
            this.get_all_data();
            this.dialog = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          //stop loader
        });
    },
    onload() {
      axios
        .post("/examination/applySchemeHome")
        .then((res) => {
          this.ay_list = res.data.academic_year_list;
          this.semester_list = res.data.semester_list;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          //stop loader
        });
    },
    deleteScheme(item) {
      
      const data={
        id: item
      }
      axios
        .post("/examination/deleteScheme",data)
        .then((res) => {
          if(res.data.flag=="YES"){
            this.showSnackbar("#4caf50",res.data.msg);
            this.dialog=false;
            
          }else if(res.data.flag=="NO"){
            this.showSnackbar("#b71c1c",res.data.msg);
          }else{
            this.showSnackbar("#b71c1c","Something went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        }) 
        .finally(() => {
          this.showConfirmationDialog=false;
        }); 
      
    },
    getstd_crs(item, ay, sem) {
      const data = {
        std: item,
        ay: ay,
        sem: sem,
      };
      axios
        .post("/examination/getstd_crs", data)
        .then((res) => {
          this.dialog = true;
          this.crs_list = res.data.crs_list;
          this.ass_scheme_list = res.data.scheme_list;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          //stop loader
        });
    },

    copyAssesmentScheme() {
      const formData = {
        ay: this.ay,
        sem: this.sem,
        prevay : this.copy_from_ay.id,
        standards : this.copyStandardList
      };
      axios
        .post("/examination/copyApplyAssesmentScheme", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.scheme_list = res.data.scheme_list;
            this.showSnackbar("#4caf50", "Assesment Scheme Copied Successfully!!!");
            this.copyDialog = false;
            this.copy_from_ay = "";
            this.copyStandardList = "";

          }else{
            this.showSnackbar("#b71c1c", res.data.msg || "Something went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          //stop loader
        });
    },
    calldeleteScheme(item){
        this.showConfirmationDialog=true;
        this.c_id = item.id

    },
    
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>
<style scoped>
.btn-css {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #fff !important;
  text-decoration: underline;
  color: #0f2027 !important;
  text-align: left;
}

.btn-css:hover {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #ffff !important;
  color: #0f2027 !important;
  text-decoration: underline;
  text-align: left;
}
.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}
</style>
